// ---------------------------------------------------------------------------
// The learned evaluation — P(win) from a position, by a trained model
// ---------------------------------------------------------------------------
//
// winProbability(result, seat, round, model) → the model's probability that
// `seat` goes on to win from resolveRound's `result`. The model is what
// scripts/train-value.py writes (valueModel.js): the features'
// standardisation and the layers of a logistic regression or a
// one-hidden-layer tanh net, its inputs looked up by name. learnedEvaluate puts it on evaluate()'s scale
// for the search: a finished war is ±10000, anything else 1000 × P(win).

import { valueFeatures, FEATURE_NAMES } from './valueFeatures.js'

// Each model's features, by name, as positions in valueFeatures' output: a
// model trained on an older (shorter) feature list keeps working.
const INDEX = new WeakMap()
function indexOf(model) {
    if (!INDEX.has(model)) {
        const idx = model.features.map(n => FEATURE_NAMES.indexOf(n))
        if (idx.some(i => i < 0)) throw new Error('valueNet: the model uses features this code does not compute — retrain it (scripts/train-value.py)')
        INDEX.set(model, idx)
    }
    return INDEX.get(model)
}

export function winProbability(result, seat, round, model) {
    const idx = indexOf(model)
    const all = valueFeatures(result, seat, round)
    let h = idx.map((j, i) => (all[j] - model.mean[i]) / model.std[i])
    model.layers.forEach((layer, li) => {
        const out = layer.b.map((b, j) => b + h.reduce((a, x, i) => a + x * layer.W[i][j], 0))
        h = li < model.layers.length - 1 ? out.map(Math.tanh) : out
    })
    return 1 / (1 + Math.exp(-h[0]))
}

export function learnedEvaluate(result, seat, round, model) {
    if (result.outcome.over) return result.outcome.draw ? 0 : result.outcome.winner === seat ? 10000 : -10000
    return 1000 * winProbability(result, seat, round, model)
}
